import { MdClose } from "react-icons/md";
import { FaDollarSign } from "react-icons/fa";
import { useState } from "react";
import { CrearMultiplesPagos } from "../../utils/automateFuncions/CrearMultiplesPagos";
import { Button, CircularProgress } from "@mui/material";
import { getToday } from "../../utils/GetDates";
import { useSelector } from "react-redux";


const AgregarMultiplesPagos = ({  open, onClose, idCotizacion, precioTotal, setPagosList, pagosList, moneda, servicios }) => {

  const user = useSelector((state) => state.auth.user);
  const { start } = getToday()

  const [isLoading, setIsLoading] = useState(false);

  const [fechaInicio, setFechaInicio] = useState(start)
  const [numeroPagos, setNumeroPagos] = useState(null)

  return (
    <div>
      {open && (
        <div
          className="max-w-2xl mx-auto bg-gray-100 p-4 shadow-lg rounded-md my-6"
        >
          <div className="flex justify-end">
            <div
              onClick={() => onClose()}
              className="cursor-pointer border border-gray-300 bg-gray-300 hover:bg-gray-400 transiton-all duration-100 p-2 rounded-md"
            >
              <MdClose className="text-black" />
            </div>
          </div>
          
          <div className=" ">
            <h3 className="text-center text-sm font-bold">Agregar múltiples pagos </h3>
          </div>

          <div className="mt-3">
            <div>
              <label
                htmlFor={"fechaInicio"}
                class="block mb-1 text-xs font-medium text-gray-900 flex flex-col gap-1"
              >
                <span className="font-semibold">Fecha inicio</span>
                <span className="text-xs text-gray-400">Fecha del primer pago, en funcion de esta fecha se calculará el pago de los siguientes meses.</span>
              </label>
              <input 
                type="date"
                placeholder="Fecha límite"
                value={fechaInicio || ''}
                min={new Date().toISOString().split('T')[0]}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border w-full border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                onChange={(e) => setFechaInicio(e.target.value)}
              />
            </div>
          </div>

          <div className="mt-3">
            <div>
              <label
                htmlFor={"fechaInicio"}
                class="block mb-1 text-xs font-medium text-gray-900 flex flex-col gap-1"
              >
                <span className="font-semibold">Total de pagos (max. 24 cuotas)</span>
                <span className="text-xs text-gray-400">El total de la cotización se dividirá entre el número de pagos que coloques acá.</span>
              </label>
              <input 
                type="number"
                placeholder=""
                value={numeroPagos || ''}
                max={24}
                min={0}
                className="text-gray-700 hover:cursor-pointer text-xs bg-white border w-full border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent py-[6px]"
                onChange={(e) => {
                  const value = parseInt(e.target.value);
                  if (value <= 24) {
                    setNumeroPagos(value);
                  } else {
                    setNumeroPagos(24);
                  }
                }}
              />
            </div>
          </div>

          <div className=" bg-gray-300 h-[1px] w-full my-4"></div>
          {fechaInicio && numeroPagos && precioTotal && (
            <div className="flex justify-between text-xs">
              <span>
                Un pago de {moneda + " "} <strong>{(precioTotal / numeroPagos).toLocaleString("en-US", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })}</strong> los <strong>{new Date(fechaInicio + 'T00:00:00-05:00').getDate()}</strong> de cada mes, durante <strong>{numeroPagos}</strong> meses.
              </span>
            </div>
          )}

          <div className="my-6 flex justify-center gap-4">
            <Button
              variant="contained"
              disabled={!fechaInicio || !numeroPagos || !precioTotal || isLoading}
              endIcon={isLoading ? <CircularProgress size={14} className="animate-spin" /> : <FaDollarSign size={14} />}
              sx={{
                fontSize: "12px",
                fontWeight: "bold",
                fontFamily: "poppins", 
                padding: "8px 24px",
                backgroundColor: "#2563eb",
                textTransform: "none",
                borderRadius: "8px",
                width: "180px",
                '&:hover': {
                  backgroundColor: "#1d4ed8",
                }
              }}
              onClick={async () => {
                setIsLoading(true);
                const pagosCreados = await CrearMultiplesPagos(precioTotal, numeroPagos, fechaInicio, idCotizacion, user.id, servicios);
                if (pagosCreados && pagosCreados.length > 0) {
                  setPagosList([...pagosList, ...pagosCreados]);
                  onClose();
                }
                setIsLoading(false);
              }}
            >
              Registrar
            </Button>
          </div>
        </div>
      )}

    </div>
  )
}

export default AgregarMultiplesPagos;

